import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="border-t mt-16">
      <div className="mx-auto max-w-6xl px-4 py-10 grid gap-8 md:grid-cols-3 text-sm">
        <div className="space-y-2">
          <div className="font-semibold">Pro Systems</div>
          <p className="text-muted-foreground max-w-sm">
            IT consulting for small and medium businesses in Bangkok. Modernize your infrastructure
            and accelerate cloud adoption.
          </p>
        </div>
        <div>
          <div className="font-medium mb-3">Company</div>
          <ul className="space-y-2 text-muted-foreground">
            <li>
              <Link to="/about" className="hover:text-foreground">
                About
              </Link>
            </li>
            <li>
              <Link to="/services" className="hover:text-foreground">
                Services
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-foreground">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div className="space-y-2">
          <div className="font-medium">Contact</div>
          <div className="text-muted-foreground">Bangkok, Thailand</div>
          <a href="tel:0804685545" className="text-accent hover:underline">
            0804685545
          </a>
        </div>
      </div>
      <div className="border-t py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Pro Systems. All rights reserved.
      </div>
    </footer>
  );
}
